/* eslint-disable react/no-danger */
import React from "react"
import { Image } from "rebass"
import propTypes from "prop-types"
import styled from "styled-components"
import Fade from "react-reveal"

import converter from "../converter"
import withTranslation from "../i18n/withTranslation"

const Container = styled.article`
  display: inline-flex;
  margin-top: 140px;

  img {
    width: 250px;
  }

  .content {
    display: flex;
    flex-direction: column;

    p {
      line-height: 1.3em;
      text-align: justify;
      font-weight: lighter;
    }
  }

  h2 {
    font-size: 1.1em;
    margin-top: 0;
  }

  .resume {
    margin-top: 20px;
  }

  &:nth-child(even) {
    flex-direction: row-reverse;
    width: 47%;
    margin-right: 2.5%;
    text-align: right;

    .content {
      padding: 0 20px 0 0;
    }
  }

  &:nth-child(odd) {
    flex-direction: row;
    width: 47%;
    margin-left: 2.5%;
    position: relative;
    top: 80px;

    .content {
      padding: 0 0 0 20px;
    }
  }

  &:nth-child(1) {
    width: 100%;
    display: flex;
    margin: 0 0 60px 0;
    padding: 0 40px;

    img {
      width: 370px;
      height: auto;
      margin-left: -80px;
      margin-right: 20px;
    }
  }

  @media screen and (max-width: 768px) {
    &:nth-child(odd),
    &:nth-child(even) {
      display: flex;
      position: relative;
      top: 0;
      width: 100%;
      flex-direction: column;
      margin: 30px 0 0 0;
      padding: 0;

      .content {
        margin: 0;
        padding: 0;
        width: 100%;
      }
    }
  }

  @media screen and (max-width: 480px) {
    &:nth-child(1),
    &:nth-child(odd),
    &:nth-child(even) {
      img {
        width: 100%;
        margin: 0;
      }
    }
  }

  @media screen and (min-width: 481px) and (max-width: 768px) {
    &:nth-child(odd),
    &:nth-child(even) {
      img {
        width: 60%;
        margin: 0 auto;
      }
    }

    &:nth-child(odd) img {
      margin: 0 0 0 auto;
    }

    &:nth-child(even) img {
      margin: 0 auto 0 0;
    }

    &:nth-child(1) {
      img {
        display: block;
        margin: 0 auto;
      }
      h1,
      h2 {
        text-align: center;
      }
    }
  }

  @media screen and (min-width: 768px) {
    &:nth-child(1) img {
      min-width: 370px;
    }
  }
`

const createMarkup = content => {
  return { __html: content }
}

const TeamItem = ({ data, i18n }) => {
  const {
    frontmatter: { avatar, name, job, jobES, bodyES },
    html,
  } = data
  const { language } = i18n

  const bio = language === "es_MX" ? converter.makeHtml(bodyES) : html

  return (
    <Container>
      <Fade>
        <Image src={avatar} alt={`${name} - ${job}`} />
        <div className="content">
          <h1>{name}</h1>
          <h2>{language === "es_MX" ? jobES : job}</h2>
          <div className="resume" dangerouslySetInnerHTML={createMarkup(bio)} />
        </div>
      </Fade>
    </Container>
  )
}

TeamItem.propTypes = {
  data: propTypes.shape({
    frontmatter: propTypes.shape({
      avatar: propTypes.string,
      name: propTypes.string,
      job: propTypes.string,
      jobES: propTypes.string,
      bodyES: propTypes.string,
    }),
    html: propTypes.string,
  }).isRequired,
  i18n: propTypes.shape({
    language: propTypes.string,
  }).isRequired,
}

export default withTranslation(TeamItem)
